import React, { useEffect, useState } from 'react'
import TableActionsWrapper from 'components/Wrapper/TableActionsWrapper';
import TableSearchWrapper from 'components/Wrapper/TableSearchWrapper';
import TableWrapper from 'components/Wrapper/TableWrapper';
import ProgressLoader from 'components/Loader/ProgressLoader';
import TablePagingWrapper from 'components/Wrapper/TablePagingWrapper';
import TablePagination, { pageOptions } from 'components/Paginate/TablePagination';
import { Badge, Button, Card, Col, Form, FormCheck, Row, Table } from 'react-bootstrap'
import { InfoCircle, List, PencilSquare, Plus, Trash } from 'react-bootstrap-icons';
import { Link, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { apiUrls } from 'constants/apiUrls';
import { userService } from 'services/userService';
import { bgUserRole } from 'utils/bgColor';
import { appRoutesUrls } from 'constants/appRoutesUrls';
import { toDDMMYYYYHHMMSS } from 'utils/dateFormatter';
import { deleteOnConfirm } from 'components/Confirm/ConfirmDialog';
import { allowNumber } from 'utils/inputValidator';
import { ButtonExportCsv, ButtonExportExcel, ButtonReset, ButtonSearch } from 'components/Buttons/Buttons';
import { BiFilterAlt } from 'react-icons/bi';

const UserList = () => {
    const navigate = useNavigate();
    const [users, setUsers] = useState();
    const [isLoader, setIsLoader] = useState(false);
    const [showMore, setShowMore] = useState(false);
    const [showFilter, setShowFilter] = useState(true);
    const initialFilters = {
        currentPage: pageOptions.currentPage,
        pageSize: pageOptions.pageSize,
        roleId: '',
        name: '',
        mobileNo: '',
        isActive: true
    };
    const [filters, setFilters] = useState(initialFilters);

    useEffect(() => {
        getUsers(filters);
    }, [])

    const getUsers = (filters) => {
        setIsLoader(true);
        userService.getUsers(apiUrls.getUsers(), filters).then(res => {
            setIsLoader(false);
            setUsers(res);
        }).catch((err) => setIsLoader(false));
    }

    const deleteUser = (id) => {
        setIsLoader(true);
        userService.deleteUser(apiUrls.deleteUser(id)).then(res => {
            setIsLoader(false);
            if (res === true) {
                toast.info("User deleted successfully!");
                getUsers(filters);
            }
        }).catch((err) => setIsLoader(false));
    }

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;

        if (name === "mobileNo" && !allowNumber(e.target.value)) { return; }

        setFilters((preValue) => ({
            ...preValue, [name]: (type === 'checkbox' ? checked : value)
        }));
    }

    const handleSearch = () => {
        let searchFilters = { ...filters, currentPage: 1 }
        setFilters(searchFilters);
        getUsers(searchFilters);
    }

    const handleReset = () => {
        setFilters(initialFilters);
        getUsers(initialFilters);
    }

    const handlePageClick = (e) => {
        let pageFilters = { ...filters, currentPage: (e.selected + 1) }
        setFilters(pageFilters);
        getUsers(pageFilters);
    }

    const handlePageSizeChange = (e) => {
        let pageFilters = { ...filters, pageSize: e.target.value, currentPage: pageOptions.currentPage }
        setFilters(pageFilters);
        getUsers(pageFilters);
    }

    const handleExport = (option) => {

    }

    return (
        <>
            {isLoader && <ProgressLoader />}
            <Card className='card-default'>
                <Card.Body>
                    <Card.Title>
                        <List size={24} /> Users {users && `(${users?.totalItems})`}
                        <BiFilterAlt size={24} className='float-end hand'
                            color={(showFilter ? '#0d6efd' : '#6c757d')}
                            onClick={() => setShowFilter(!showFilter)} />
                    </Card.Title>
                    {showFilter && (
                        <TableSearchWrapper>
                            <Form noValidate>
                                <Row>
                                    <Col md={3}>
                                        <Form.Select
                                            name='roleId'
                                            value={filters.roleId}
                                            onChange={handleChange}
                                            className="mb-2">
                                            <option value="">All Roles</option>
                                            <option value="1">SuperAdmin</option>
                                            <option value="2">Admin</option>
                                            <option value="3">Staff</option>
                                        </Form.Select>
                                    </Col>
                                    <Col md={3}>
                                        <Form.Control
                                            type="text"
                                            placeholder="Name"
                                            name='name'
                                            value={filters.name}
                                            onChange={handleChange}
                                            maxLength={20}
                                            className="mb-2" />
                                    </Col>
                                    <Col md={3}>
                                        <Form.Control
                                            type="text"
                                            placeholder="Mobile No"
                                            name='mobileNo'
                                            value={filters.mobileNo}
                                            onChange={handleChange}
                                            maxLength={10}
                                            className="mb-2" />
                                    </Col>
                                    <Col md={1} sm={6}>
                                        <Form.Check
                                            type="checkbox"
                                            name='isActive'
                                            checked={filters.isActive}
                                            onChange={handleChange}
                                            label="Active"
                                            className='mb-2'
                                        />
                                    </Col>
                                    <Col md={2} sm={6} className="text-right">
                                        <ButtonSearch onClick={handleSearch} />
                                        <ButtonReset onClick={handleReset} />
                                    </Col>
                                </Row>
                            </Form>
                        </TableSearchWrapper>
                    )}
                    <TableActionsWrapper>
                        <Row className='mt-1'>
                            <Col sm={8}>
                                <Button
                                    size="sm"
                                    type="button"
                                    variant="primary"
                                    className='mw-100'
                                    onClick={() => navigate(appRoutesUrls.userAdd())}>
                                    <Plus size={24} /> User
                                </Button>
                            </Col>
                            <Col sm={4} className='text-right'>
                                <ButtonExportExcel onClick={() => handleExport('excel')} />
                                <ButtonExportCsv onClick={() => handleExport('csv')} />
                                <FormCheck
                                    type="switch"
                                    className='ms-2 float-end'
                                    label=""
                                    onChange={() => setShowMore(!showMore)}
                                    title={`Show ${showMore ? 'Less' : 'More'} Columns`}
                                />
                            </Col>
                        </Row>
                    </TableActionsWrapper>
                    <TableWrapper>
                        <Table striped hover responsive>
                            <thead>
                                <tr>
                                    <th className='col-action-120'>Action</th>
                                    <th>ID&nbsp;</th>
                                    <th>First Name</th>
                                    <th>Last Name</th>
                                    <th>Username</th>
                                    <th>Mobile No</th>
                                    <th>Email</th>
                                    <th>Role</th>
                                    {showMore &&
                                        <>
                                            <th>Added Date</th>
                                            <th>Added By</th>
                                            <th>Modified Date</th>
                                            <th>Modified By</th>
                                        </>
                                    }
                                </tr>
                            </thead>
                            <tbody>
                                {users?.items && users?.items.map((user, i) => (
                                    <tr key={i}>
                                        <td>
                                            <Button
                                                as={Link}
                                                variant="primary"
                                                size='sm'
                                                className='btn-action'
                                                to={appRoutesUrls.userView(user.id)}>
                                                <InfoCircle />
                                            </Button>
                                            <Button
                                                as={Link}
                                                size='sm'
                                                variant="secondary"
                                                className='btn-action ms-1'
                                                to={appRoutesUrls.userEdit(user.id)}>
                                                <PencilSquare />
                                            </Button>
                                            {user.isActive && (
                                                <Button
                                                    size='sm'
                                                    variant="danger"
                                                    className='btn-action ms-1'
                                                    onClick={() => deleteOnConfirm(user.id, deleteUser, null)}>
                                                    <Trash />
                                                </Button>
                                            )}
                                        </td>
                                        <td>{user.id}</td>
                                        <td>{user.firstName}</td>
                                        <td>{user.lastName}</td>
                                        <td>{user.username}</td>
                                        <td>{user.mobileNo}</td>
                                        <td>{user.email}</td>
                                        <td>
                                            <Badge bg={bgUserRole(user.role)} className='mw-80'>
                                                {user.role}
                                            </Badge>
                                        </td>
                                        {showMore &&
                                            <>
                                                <td>{toDDMMYYYYHHMMSS(user.addedDate)}</td>
                                                <td>{user.addedBy}</td>
                                                <td>{toDDMMYYYYHHMMSS(user.modifiedDate)}</td>
                                                <td>{user.modifiedBy}</td>
                                            </>
                                        }
                                    </tr>
                                ))}
                            </tbody>
                        </Table>
                    </TableWrapper>
                    <TablePagingWrapper>
                        <TablePagination
                            pageSize={filters.pageSize}
                            currentPage={filters.currentPage}
                            totalPages={users?.totalPages}
                            totalItems={users?.totalItems}
                            onPageChange={handlePageClick}
                            onPageSizeChange={handlePageSizeChange}
                            pageTitle="Users"
                        />
                    </TablePagingWrapper>
                </Card.Body>
            </Card>
        </>
    )
}

export default UserList;